export {
  type Dimension,
  getBackgroundPositionFromFrame,
  getDimensions,
  getSpriteStyles,
} from '@air/utils-clips';

export const SCRUBBABLE_THUMBNAIL_INDICATOR_WIDTH = 2;
